import moment from 'moment';
import { DATASET_CATEGORIES } from '../utils/filterBestDataset';
import { ReactNode } from 'react';
import {IEnrichedMetadata} from "./metadata";

interface IItem {
  Time: string;
  'Sign._Wave_Height': number;
  Peak_Wave_Direction: number;
}

interface ILabeledDataset {
  label: string;
  value: string;
  id: string;
}

export interface IItemsInfo {
  Name: string;
  ShortName: string | null;
  Unit: string | null;
  Index: number;
}

export interface IItemsValidation {
  name: string,
  id: string,
  description: string,
  details: string,
  unit: string
}

interface IDirections {
  Name: string;
  Max: number;
  Min: number;
}

interface IRanges {
  Name: string;
  Max: number;
  Min: number;
  Frequency: number;
}

interface IAxis {
  Name: string;
  Type: string;
  Unit: string;
}

export interface IPreviewData {
  RequestId: string;
  OrderId: string;
  Acronym: string;
  ShortTitle: string;
  DefaultDirectionShortName: string;
  DefaultValueShortName: string;
  Data: {
    Items: IItem[];
    Count: number;
  };
  ItemsInfo: IItemsInfo[];
  StartDate: string;
  EndDate: string;
  RosePlot: RosePlotChart;
  RosePlotDefaultInterval: number;
  RosePlotDefaultDirectionShortName: string;
  RosePlotDefaultValueShortName: string;
}

export interface IRosePlotPreviewData {
  Acronym?: string;
  ShortTitle?: string;
  RosePlot: RosePlotChart;
  RosePlotDefaultInterval?: number;
  ItemsInfo?: IItemsInfo[];
  DefaultDirectionShortName: string;
  DefaultValueShortName: string;
}

export interface IPreviewAnalytic {
  datasetId: string;
  data: IPreviewData;
  rosePlotPreviewdata?: IRosePlotPreviewData;
  coordinates: number[];
}

export interface IAnalytic {
  basic: any;
  // postfix: string;
  disabled: boolean | undefined;
  id: string;
  name: string;
}

export interface IValidation {
  basic: any;
  postfix: string;
  disabled: boolean | undefined;
  id: string;
  name: string;
}

export interface IChartBox {
  title: string;
  dataset: string;
  actionRow?: React.ReactNode;
  plot?: React.ReactNode;
  height?: string | number;
  showDisclaimer?: boolean | undefined;
  limitation?: ReactNode;
  showAxis?: boolean;
  xAxis?: IPlotVariable | undefined;
  yAxis?: IPlotVariable | undefined;
  link?: string[]
  customLink?: ReactNode
}

export interface IAnalyticsDownloadLinks {
  links: string[];
}

export interface IChartItem {
  Index: number;
  Name: string;
  ShortName: string | null;
  Unit: string | null;
}

export interface IPlotVariable {
  Name: string;
  ShortName: string | null;
  Unit: string | null;
  Index: number;
}

export interface RosePlotChart {
  RosePlotDefaultInterval?: number;
  Axises: Array<IAxis>;
  Directions?: RosePlotDataItem[];
  Ranges?: RosePlotDataItem[];
  Data?: { [key: string]: RosePlotDataItem[] };
  StartDate: string;
  EndDate: string;
  ItemsInfo: IItemsInfo[];
  Title: string;
  Status: true;
  Error?: any;
  Type: string;
  Location: string;
}

export interface RosePlotDataItem {
  Name: string;
  Max: number;
  Min: number;
  Frequency?: number;
}

export interface IBestDataset {
  label: string | DATASET_CATEGORIES;
  value: string | DATASET_CATEGORIES;
  id: string;
  key?: string;
  disabled?: boolean
}

export interface DownloadInfoItem {
  radioKey: string;
  datasetId: string;
  options: IBestDataset[];
  dateRange?: [moment.Moment, moment.Moment];
  waterDepth?: string;
  gridCellSize?: string;
}

export interface AnalyticsStore {
  previewAnalytics: IPreviewAnalytic[];
  setPreviewAnalytics: (analytics: IPreviewAnalytic[]) => void;

  enrichedMetadata: IEnrichedMetadata[];
  setEnrichedMetadata: (enrichedMetadata: IEnrichedMetadata[]) => void
}
export enum ADVANCED_ANALYTICS {
  PERSISTENCE_WEATHERWINDOW = 'persistence (weather windows)',
  EXTREME_VALUES = 'extreme values',
  HISTOGRAM = 'histogram',
  EXCEEDANCE = 'exceedance probability',
  ALTIMETER_COMPARISON = 'altimeter comparison',
  TIDAL_LEVEL = 'tidal parameters',
  STATISTICS = 'monthly statistics',
  SCATTER_PLOT_INSITU = 'scatter_comparison'
}

export enum PREPROCESSED_ANALYTICS {
  XLS = 'Pre-processed Analytics',
}

export enum BASIC_ANALYTICS {
  TIME_SERIES = 'Time Series',
  ROSE_PLOT = 'Rose Plot',
  SCATTER_PLOT = 'Scatter Plot'
}

export const DEFAULT_ANALYTICS = BASIC_ANALYTICS.TIME_SERIES.toLowerCase()
export const DEFAULT_VALIDATION = 'satellite'

